import { c as _c } from "react/compiler-runtime";
import useModalStore from '@module/stores/useModalStore';
import TimeConstants from '@module/utils/item';
import { useEffect, useRef } from 'react';
const SEARCH_REFERRERS = ['google.com', 'search.naver.com'] as const;
const SEARCH_REFERRER_MODAL_ID = 'PartnerComp - search-referrer';
const HASH_JOIN_MODAL_ID = 'PartnerComp - hash-join';
const SEARCH_REFERRER_MODAL_RETRY_DELAY_MS = TimeConstants.ONE_SECOND * 5;
const SEARCH_REFERRER_MODAL_REOPEN_RECHECK_MS = TimeConstants.ONE_SECOND;
const SEARCH_REFERRER_MODAL_MAX_REOPEN_COUNT = 2;
interface UsePartnerSignupEntryPromptParams {
  isLogin: boolean;
  isLoginInfoFetching: boolean;
}

/**
 * 파트너 회원가입 유입 케이스를 한 곳에서 관리한다.
 * - 검색 엔진 유입: 회원가입 모달 노출, 닫으면 5초 후 최대 2회 재노출
 * - #join 해시 유입: 회원가입 모달 1회 노출
 */
function usePartnerSignupEntryPrompt(t0) {
  const $ = _c(17);
  const {
    isLogin,
    isLoginInfoFetching
  } = t0;
  const pushModal = useModalStore(_temp);
  const hasCheckedEntryRef = useRef(false);
  const reopenCountRef = useRef(0);
  const retryTimeoutRef = useRef(null);
  const latestIsLoginRef = useRef(isLogin);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (retryTimeoutRef.current === null) {
        return;
      }
      window.clearTimeout(retryTimeoutRef.current);
      retryTimeoutRef.current = null;
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const clearRetryTimeout = t1;
  let openSearchReferrerRegisterModal;
  if ($[1] !== pushModal) {
    openSearchReferrerRegisterModal = () => {
      pushModal({
        type: "AUTH_MODAL",
        id: SEARCH_REFERRER_MODAL_ID,
        options: {
          tab: "register",
          onClose: () => {
            if (reopenCountRef.current >= SEARCH_REFERRER_MODAL_MAX_REOPEN_COUNT) {
              clearRetryTimeout();
              return;
            }
            reopenCountRef.current = reopenCountRef.current + 1;
            scheduleSearchReferrerRegisterModal();
          }
        }
      });
    };
    const scheduleSearchReferrerRegisterModal = t2 => {
      const delayMs = t2 === undefined ? SEARCH_REFERRER_MODAL_RETRY_DELAY_MS : t2;
      clearRetryTimeout();
      retryTimeoutRef.current = window.setTimeout(() => {
        if (latestIsLoginRef.current) {
          retryTimeoutRef.current = null;
          return;
        }
        if (useModalStore.getState().modal.length > 0) {
          scheduleSearchReferrerRegisterModal(SEARCH_REFERRER_MODAL_REOPEN_RECHECK_MS);
          return;
        }
        retryTimeoutRef.current = null;
        openSearchReferrerRegisterModal();
      }, delayMs);
    };
    $[1] = pushModal;
    $[2] = openSearchReferrerRegisterModal;
  } else {
    openSearchReferrerRegisterModal = $[2];
  }
  let t2;
  let t3;
  if ($[3] !== isLogin) {
    t2 = () => {
      latestIsLoginRef.current = isLogin;
      if (isLogin) {
        clearRetryTimeout();
      }
    };
    t3 = [isLogin];
    $[3] = isLogin;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== isLogin || $[7] !== isLoginInfoFetching || $[8] !== openSearchReferrerRegisterModal || $[9] !== pushModal) {
    t4 = () => {
      if (hasCheckedEntryRef.current) {
        return;
      }
      if (isLoginInfoFetching) {
        return;
      }
      if (isLogin) {
        hasCheckedEntryRef.current = true;
        return;
      }
      const {
        href
      } = window.location;
      const referrer = document.referrer;
      const isSearchReferrer = SEARCH_REFERRERS.some(domain => referrer.includes(domain));
      const hasJoinHash = href.includes("#join");
      if (isSearchReferrer) {
        openSearchReferrerRegisterModal();
        hasCheckedEntryRef.current = true;
        return;
      }
      if (hasJoinHash) {
        pushModal({
          type: "AUTH_MODAL",
          id: HASH_JOIN_MODAL_ID,
          options: {
            tab: "register"
          }
        });
      }
      hasCheckedEntryRef.current = true;
    };
    $[6] = isLogin;
    $[7] = isLoginInfoFetching;
    $[8] = openSearchReferrerRegisterModal;
    $[9] = pushModal;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== isLogin || $[12] !== isLoginInfoFetching || $[13] !== pushModal) {
    t5 = [pushModal, isLoginInfoFetching, isLogin];
    $[11] = isLogin;
    $[12] = isLoginInfoFetching;
    $[13] = pushModal;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => () => {
      clearRetryTimeout();
    };
    t7 = [];
    $[15] = t6;
    $[16] = t7;
  } else {
    t6 = $[15];
    t7 = $[16];
  }
  useEffect(t6, t7);
}
function _temp(state) {
  return state.pushModal;
}
export default usePartnerSignupEntryPrompt;